import { Meetingroom } from '../../../interfaces/interfaces';
import { store } from '../../../reduxToolkit/store';
import { VYSTEMBLUE } from '../../../static/constants';

export function addOverlayElement(el: HTMLElement, overlayText: string) {
  const overlay = document.createElement('div');
  overlay.style.position = 'relative';

  overlay.style.width = '100%';
  overlay.style.height = '100%';
  overlay.style.fontSize = '1.1rem';
  overlay.style.color = 'white';
  overlay.style.zIndex = '10';

  const text = document.createElement('p');
  text.style.position = 'absolute';
  text.style.bottom = '0';
  text.style.left = '0';
  text.style.color = 'white';
  text.style.backgroundColor = 'black';
  text.style.padding = '1vh';
  text.style.borderRadius = '10px';
  text.style.marginBottom = '2vh';
  text.style.opacity = '0.3';
  text.textContent = overlayText;

  overlay.appendChild(text);

  el.appendChild(overlay);
}

export function getMicLevelIndicator(id: string, bottom?: string) {
  const el = document.createElement('div');
  el.style.position = 'relative';
  el.style.width = '100%';
  el.style.height = '100%';

  const div = document.createElement('div');
  div.style.position = 'absolute';
  div.style.left = '20px';
  div.style.bottom = bottom ?? '40px';
  div.style.backgroundColor = VYSTEMBLUE;
  div.style.borderRadius = '20px';
  div.style.height = '25px';
  div.style.width = '25px';
  div.className = 'flex items-center justify-around m-2 opacity-70 hover:opacity-100';

  el.appendChild(div);

  const meter1 = document.createElement('div');
  meter1.id = `${id}-1`;
  meter1.style.width = '5px';
  meter1.style.height = '5px';
  meter1.style.borderRadius = '5px';
  meter1.style.backgroundColor = 'white';
  meter1.style.minHeight = '5px';
  meter1.style.maxHeight = '20px';

  const meter2 = document.createElement('div');
  meter2.id = `${id}-2`;
  meter2.style.width = '5px';
  meter2.style.height = '5px';
  meter2.style.borderRadius = '5px';
  meter2.style.backgroundColor = 'white';
  meter2.style.minHeight = '5px';
  meter2.style.maxHeight = '40px';

  const meter3 = document.createElement('div');
  meter3.id = `${id}-3`;
  meter3.style.width = '5px';
  meter3.style.height = '5px';
  meter3.style.borderRadius = '5px';
  meter3.style.backgroundColor = 'white';
  meter3.style.minHeight = '5px';
  meter3.style.maxHeight = '20px';

  const muteIcon = document.createElement('img');
  muteIcon.id = `${id}-mute-icon`;
  muteIcon.src = '/micoff.png';
  muteIcon.style.width = '20px';
  muteIcon.style.height = '20px';
  muteIcon.style.minHeight = '20px';
  muteIcon.style.maxHeight = '20px';
  muteIcon.style.position = 'absolute';
  muteIcon.style.color = 'white';
  muteIcon.style.opacity = '0';

  div.appendChild(meter1);
  div.appendChild(meter2);
  div.appendChild(meter3);
  div.appendChild(muteIcon);

  return el;
}

export function addDoubleclickResize(el: HTMLElement) {
  el.addEventListener('dblclick', function () {
    if (el.classList.contains('OT_big')) {
      el.classList.remove('OT_big');
    } else {
      el.classList.add('OT_big');
    }
    store.getState().video.layout?.layout();
  });
}

export function getEventId(meeting: Meetingroom): string {
  if (meeting.meetingtype === 'presentation' || meeting.meetingtype === 'meeting' || meeting.meetingtype === 'conference') {
    return meeting.booth?.event?._id;
  } else {
    return meeting.event?._id;
  }
}

export function addClickevent() {}

export function apiKeyBasedOnEnv(isSimulcast: boolean): string {
  console.log('Using baseurl for meeting', process.env.baseURL);
  if (process.env.baseURL === 'https://staging.app.vystem.io') {
    console.log('Using staging key');
    return isSimulcast ? '47593581' : '47207244';
  }

  if (process.env.baseURL === 'https://app.vystem.io') {
    console.log('Using production key');
    return isSimulcast ? '47593601' : '47207254';
  }

  return isSimulcast ? '47593571' : '47207234';
}
